module.exports = __webpack_public_path__ + "img/roundPlus.61ad9bdb.svg";